module.exports = __webpack_public_path__ + "img/user.4f5b29ff.svg";